import { Box, CircularProgress } from '@material-ui/core';

export default function LoaderContainer() {
  return (
    <Box m={5} textAlign="center">
      <CircularProgress color="secondary" size={50} aria-label="Loading." />
    </Box>
  );
}
